import { render, staticRenderFns } from "./mygoods.vue?vue&type=template&id=084e4a6f"
import script from "./mygoods.vue?vue&type=script&lang=js"
export * from "./mygoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports